import { useEffect } from "react";
import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import React from "react";

export type NotesModalProps = {
    show: boolean;
    notes: string;
    onCancelNotes: () => void;
    onConfirmNotes: () => void;
};

export default function NotesModal({
    show,
    notes,
    onCancelNotes,
    onConfirmNotes,
}: NotesModalProps) {
    //const [show, setShow] = useState(true);
    const [position, setPosition] = useState({ x: 400, y: 200 });
    const [size, setSize] = useState({ width: 600, height: 600 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

    const [notesCheck, setNotesCheck] = useState(false);

    // const handleClose = () => setShow(false);

    // Dragging Logic
    const handleMouseDown = (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        setIsDragging(true);
        setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
    };

    const handleMouseMove = (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        if (isDragging) {
            setPosition({
                x: e.clientX - dragStart.x,
                y: e.clientY - dragStart.y,
            });
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    const closeWindow = () => {
        onConfirmNotes();
    };

    const confirm = () => {
        onConfirmNotes();
    };

    return (
        <Modal
            show={show}
            onHide={onCancelNotes}
            backdrop={false}
            keyboard={true}
            dialogClassName="movable-modal"
            enforceFocus={false} // Prevent focus trapping
            className="notes-modal"
            //size={"lg"}
            style={{
                top: position.y,
                left: position.x,
                position: "absolute",
                width: size.width,
                height: size.height,
                border: "4px solid #ff0000", // Add a border
                borderRadius: "8px", // Optional rounded corners
                zIndex: 1050, // Ensure modal stays above other elements
                pointerEvents: "auto", // Ensure modal handles its own events
                margin: "0",
                paddingRight: "0",
            }}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
        >
            <Modal.Header
                style={{
                    cursor: "grab",
                }}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
            >
                <Modal.Title style={{ cursor: "grab", padding: "0" }}>
                    Filing Notes
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ width: size.width, height: size.height }}>
                <pre>{notes}</pre>
            </Modal.Body>
            <Modal.Footer
                style={{ cursor: "grab", padding: "0" }}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
            >
                <button
                    className="btn btn-primary"
                    type="submit"
                    onClick={onConfirmNotes}
                >
                    Confirm
                </button>
                <Button variant="secondary" onClick={onCancelNotes}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
